import {Inject, Injectable} from '@angular/core';
import {AuthConfig, OAuthService} from "angular-oauth2-oidc";

@Injectable()
export class AuthZeroService {

  constructor(@Inject(OAuthService) private oauthService: OAuthService) {

  }

  configure(config: AuthConfig) {
    this.oauthService.configure(config);
  }

  setStorage() {
    this.oauthService.setStorage(localStorage);
  }

  loadDiscoveryDocument() {
    return this.oauthService.loadDiscoveryDocument();
  }

  loadDiscoveryDocumentAndTryLogin() {
    return this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }

  tryLoginCodeFlow() {
    return this.oauthService.tryLoginCodeFlow();
  }

  initCodeFlow() {
    this.oauthService.initCodeFlow();
  }

  initLoginFlowInPopup() {
    return this.oauthService.initLoginFlowInPopup();
  }

  setupAutomaticSilentRefresh() {
    this.oauthService.setupAutomaticSilentRefresh();
  }

  hasValidAccessToken() {
    return this.oauthService.hasValidAccessToken();
  }

  getIdentityClaims() {
    return this.oauthService.getIdentityClaims();
  }

  getAccessToken() {
    return this.oauthService.getAccessToken();
  }


  logout() {
    this.oauthService.logOut();
  }




}
